import { HTTPError } from 'ky';
import { getCookie, removeCookie } from 'tiny-cookie';

import {
  captchaCancelled,
  type CaptchaToken,
} from '@/Providers/CaptchaContextProvider/CaptchaContext';

const cookieName = 'sms_bypass_token';

/** Cookie presence only skips the widget; the server still validates the credential. */
export async function sendWithSmsBypass<T>(
  executeCaptcha: () => Promise<CaptchaToken>,
  send: (token?: string) => Promise<[unknown, T?]>
): Promise<[unknown, T?]> {
  const bypass = Boolean(getCookie(cookieName));
  const token = bypass ? undefined : await executeCaptcha();
  if (token === captchaCancelled) {
    return [null];
  }

  const result = await send(token);
  const [error] = result;
  if (!bypass || !(error instanceof HTTPError) || error.response.status !== 422) {
    return result;
  }

  const body: unknown = await error.response
    .clone()
    .json()
    .catch(() => null);
  if (
    !body ||
    typeof body !== 'object' ||
    !('code' in body) ||
    body.code !== 'session.captcha_required'
  ) {
    return result;
  }

  removeCookie(cookieName, { path: '/' });
  const captchaToken = await executeCaptcha();
  return captchaToken === captchaCancelled ? [null] : send(captchaToken);
}
